import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import { Icon, Button } from 'semantic-ui-react';
import styled from 'styled-components';
import { Link } from "react-router-dom";

const expandSize 			= '280px';
const compactSize 		= '5rem';
const borderRadius 		= '.3em';
const sidebarPadding	= '.8';

const Layout = styled.div`
	flex: 0;
	flex-basis: ${({ expand }) => expand ? expandSize : compactSize};
	width: ${({ expand }) => expand ? expandSize : compactSize};
	
	display: flex;
	flex-direction: column;
	height: 100%;
	padding: ${sidebarPadding}rem;
	background-color: #F4F6F8;
	box-shadow: 1px 0 4px 0px rgba(121, 121, 122, .2);
	
	@media only screen and (max-width: 768px) {
		flex-basis: ${expandSize};
		width: ${expandSize};
		padding: 0; margin: 0;
		margin-left: ${({ visible }) => visible ? "0px": `-${expandSize}`};
	  transition: all ease-in-out 200ms;

		> .lg { display: none; }
	}
`;

const ListLayout = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	margin: .2em 0;
	padding: .2em 0;
	border-radius: ${borderRadius};
	${({ active }) => active && 'background-color: #fff;'}
`;
const ItemLayout = styled.div`
	display: flex;
	width: 100%;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	min-height: ${({ parent }) => parent ? '50px' : '32px'};
`;
const Left = styled.div`
	${({ expand }) => expand && 'margin-right: .8em;'}
	flex-basis: calc(${compactSize} - ${sidebarPadding * 2}rem);
	width: calc(${compactSize} - ${sidebarPadding * 2}rem);
	min-width: calc(${compactSize} - ${sidebarPadding * 2}rem);
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: ${borderRadius};
	${({ active }) => active && 'background-color: #fff;'}
`;
	
const Right = styled.div`
	border-radius: ${borderRadius};
	padding-right: .4em;
	flex-grow: 1;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	${({ active }) => active && 'background-color: #fff;'}
`;
const SubLayout = styled.div`
	flex-basis: ${({ parent }) => parent ? '50px': '32px' };
	display: flex;
	position: relative;
	align-items: center;
`;
const MainMenuContainer = styled.div`
	position: absolute;
	height: 100%;
	width: 100%;
	overflow: hidden;
	&:hover { overflow-y: auto; }

	@media only screen and (max-width: 768px) {
		overflow-y: auto;
	}
	@media only screen and (min-width: 768px) {
		
	}
	@media only screen and (min-width: 992px) {
		
	}
	@media only screen and (min-width: 1600px) {
		
	}
`;

const MenuItem = ({
	expand, active, parent, shown,
	menu, menuIdx, logo, to, child, pathname,
	onClick, handleExpandMenu, toggleSidebar
}) => {
	let is_active = active;
	const [hover, setHover] = useState(false);
	const handleMouseEnter = (e, data) => { return setHover(true); };
	const handleMouseLeave = (e, data) => { return setHover(false); };

	if (!parent) { is_active = (new RegExp(`^${to}`)).test(pathname); }
	// console.log(is_active, to, pathname, menu, onClick);
	return (<ItemLayout expand={expand} parent={parent}
		onMouseEnter={handleMouseEnter}
		onMouseLeave={handleMouseLeave}
	>
		<Left expand={expand} active={active}>
			{logo && <Button basic color="theme" active={active || hover} className="sidebar-btn">
				{expand
					? <Link to={to || ""}>
						<Icon className={logo} size="big" style={{ margin: '0px' }} />
					</Link>
					: <div><Icon className={logo} size="big" style={{ margin: '0px' }} onClick={toggleSidebar} /></div>
				}
			</Button>}
		</Left>
		{expand && <Right expand={expand}>
			<SubLayout parent={parent}>
				<div style={{ flex: 1 }}>
					<Button basic color="theme" active={active || is_active || hover} className="sidebar-btn" style={{ width: '100%', textAlign: 'left' }}>
						{_.isFunction(onClick)
							? <span onClick={onClick}>{menu}</span>
							: <Link to={to || ""}>{menu}</Link>}
					</Button>
				</div>
				{!_.isEmpty(child) && parent && active && <div><Button idx={menuIdx} basic color="theme" className="sidebar-btn" icon={shown ? "angle up" : "angle down"} size="large" onClick={handleExpandMenu} /></div>}
			</SubLayout>
		</Right>}
	</ItemLayout>);
}

const Sidebar = ({ visible, expand, toggle, header, menu, footer, location}) => {
	const { pathname } = location;

	const [listMenu, setListMenu] = useState([]);

	useEffect(() => {
		const temp = [...menu.map(o => _.cloneDeep(o))];
		temp.map((o) => {
			const { parent, child = []} = o;
			o.list_route = _.chain([parent.to, ...child.map(oo => oo.to)]).compact().uniq().value();
			let status = false;
			o.list_route.map((item) => {
				const regex = new RegExp(`^${item}`, 'gi');
				if (regex.test(pathname)) { status = true; }
			});
			_.set(o, 'active', status); _.set(o, 'shown', status);
		});
		setListMenu(temp);
	}, [pathname]);

	const handleExpandMenu = (e, data) => {
		const { idx } = data;
		const temp = [...listMenu];
		const current = _.get(temp, [idx, 'shown']) || false;
		_.set(temp, [idx, 'shown'], !current);
		return setListMenu(temp);
	}

	const toggleSidebar = () => {
		let temp = [...listMenu]
		if (expand) {
			temp = temp.map(o => { o.shown = false; return o; });
		} else {
			temp = temp.map(o => {
				if (o.active) { o.shown = true; }
				return o;
			});
		}
		setListMenu(temp);
		return toggle();
	}

	const handleMouseEnter = (e, data) => {
		if (!expand) { return; }
		let list = [];
		const splitted = _.get(data, 'key', '').split('-');
		if (splitted[0] === 'menu') { list = [...listMenu]; }
		const item = _.get(list, _.last(splitted), {});
		if (item.active) { return;}
		_.set(item, 'shown', true);
		return setListMenu(list);
	}
	const handleMouseLeave = (e, data) => {
		if (!expand) { return; }
		let list = [];
		const splitted = _.get(data, 'key', '').split('-');
		if (splitted[0] === 'menu') { list = [...listMenu]; }
		const item = _.get(list, _.last(splitted), {});
		if (item.active) { return; }
		_.set(item, 'shown', false);
		return setListMenu(list);
	}

	return (<Layout expand={expand} visible={visible}>
		{/* HEADER */}
		<ListLayout className="lg">
			{ header.map(({ control, left, key, right, list = [], style }) => {
				return (<ItemLayout key={_.snakeCase(key)} expand={expand} parent={list.length <= 1} style={style}>
					<Left expand={expand}>
						{ control 
							? <Button basic color="theme" icon={expand ? "angle double left" : "angle double right"} className="sidebar-btn" onClick={toggleSidebar}/>
							: left }
					</Left>
					{expand && <Right expand={expand}>{right}</Right>}
				</ItemLayout>)
			}) }
		</ListLayout>
		
		{/* MAIN MENU */}
		<div style={{ flex: 1, width: '100%', height: '100%', position: 'relative' }}>
			<MainMenuContainer>
				{
					listMenu.map(({ role, parent, child = [], active, shown }, menuIdx) => {
						// console.log({ active, shown });
						const list = [_.assign({ parent: true, active }, parent)];
						if (shown) { list.push(...child); }
						const key = ['menu', menuIdx].join('-');
						return (<ListLayout key={_.snakeCase([role, menuIdx].join('_'))} active={active}
							onMouseEnter={(e) => handleMouseEnter(e, { key })} onMouseLeave={(e) => handleMouseLeave(e, { key })}
						>
							{list.map(({ menu, logo, parent, active, to, onClick }) => {
								const props = {
									expand, active, parent, shown,
									menu, menuIdx, logo, to, child, pathname,
									onClick, handleExpandMenu, toggleSidebar
								};
								return <MenuItem key={_.snakeCase(menu)} {...props} />;
							})}
						</ListLayout>);
					})
				}
			</MainMenuContainer>
		</div>

		{/* FOOTER */}
		{visible && <ListLayout>
			{ footer.map(({ left, key, right, list = [], style }) => {
				return (<ItemLayout key={_.snakeCase(key)} expand={expand} parent={list.length <= 1} style={style}>
					<Left expand={expand}>{left}</Left>
					{expand && <Right expand={expand}>{right}</Right>}
				</ItemLayout>)
			}) }
		</ListLayout>}
	</Layout>);
};

export default Sidebar;